import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

import { Component } from 'react';
import { TraceLine } from './TraceLine.js';
import style from './Exception.css';
export var BackgroundException = /*#__PURE__*/function (_Component) {
  _inherits(BackgroundException, _Component);

  var _super = _createSuper(BackgroundException);

  function BackgroundException() {
    var _this;

    _classCallCheck(this, BackgroundException);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      expanded: false
    });

    _defineProperty(_assertThisInitialized(_this), "clickHandler", function () {
      _this.setState({
        expanded: !_this.state.expanded
      });
    });

    return _this;
  }

  _createClass(BackgroundException, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var traceElements;
      var jobArguments;

      if (this.state.expanded) {
        traceElements = this.props.Trace.map(function (trace, i) {
          return /*#__PURE__*/React.createElement(TraceLine, _extends({
            key: i
          }, trace));
        });

        if (this.props.jobArguments.substr) {
          jobArguments = this.props.jobArguments;
        } else {
          jobArguments = '{\n' + Object.keys(this.props.jobArguments).map(function (key) {
            return "\t".concat(key, ": ").concat(JSON.stringify(_this2.props.jobArguments[key]));
          }).join(',\n') + '\n}';
        }

        traceElements = /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("pre", null, /*#__PURE__*/React.createElement("span", {
          className: style.exception
        }, this.props.jobClass), " ", jobArguments), /*#__PURE__*/React.createElement("ol", {
          className: style.trace,
          start: "0"
        }, traceElements));
      } else {
        traceElements = [];
      }

      return /*#__PURE__*/React.createElement("span", {
        className: style.exceptionRow + ' ' + (this.state.expanded ? style.expanded : style.retracted),
        onClick: this.clickHandler
      }, "Error while running background job\xA0", /*#__PURE__*/React.createElement("span", {
        className: style.exception
      }, "(", this.props.Exception, ")"), ":", /*#__PURE__*/React.createElement("span", {
        className: style.messsage
      }, " ", this.props.Message), traceElements);
    }
  }, {
    key: "__reactstandin__regenerateByEval",
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);

  return BackgroundException;
}(Component);
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(BackgroundException, "BackgroundException", "/srv/http/owncloud/apps/logreader/js/Components/BackgroundException.js");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();